import { useEffect, useState } from "react";
import { http } from "../../lib/api";
import { useRealtime } from "../../context/RealtimeContext";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
const STATUS = { completed: ["Complète", "bg-emerald-100 text-emerald-800"], incomplete: ["Incomplète", "bg-amber-100 text-amber-900"], in_progress: ["En cours", "bg-sky-100 text-sky-800"] };

export function RoundRunsList() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const { lastEvent } = useRealtime();
  const load = () => http.get("/rounds/runs").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  useEffect(() => { if (lastEvent?.event === "round_changed") load(); }, [lastEvent]);
  return (
    <div className="bg-white border border-slate-200 rounded-lg overflow-x-auto" data-testid="round-runs-list">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
          <tr><th className="text-left px-4 py-2">Début</th><th className="text-left px-4 py-2">Ronde</th><th className="text-left px-4 py-2">Agent</th><th className="text-left px-4 py-2">Points</th><th className="text-left px-4 py-2">Durée</th><th className="text-left px-4 py-2">Statut</th></tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {items.length === 0 && <tr><td colSpan={6} className="p-5 text-center text-slate-500">Aucun passage enregistré.</td></tr>}
          {items.map((r) => {
            const [l, cls] = STATUS[r.status] || STATUS.in_progress;
            return [
              <tr key={r.id} data-testid={`round-run-${r.id}`} onClick={() => setOpen(open === r.id ? null : r.id)} className="cursor-pointer hover:bg-slate-50">
                <td className="px-4 py-2">{fmt(r.started_at)}</td>
                <td className="px-4 py-2"><div className="font-semibold">{r.circuit_name}</div><div className="text-xs text-slate-500">{r.site_name}</div></td>
                <td className="px-4 py-2">{r.agent_name}</td>
                <td className="px-4 py-2">{r.scans.length}/{r.expected.length}</td>
                <td className="px-4 py-2">{r.duration_min != null ? `${r.duration_min} min` : "—"}{r.late && <span className="ml-1 text-rose-600 font-semibold">dépassée</span>}</td>
                <td className="px-4 py-2"><span className={`text-xs font-bold rounded px-2 py-0.5 ${cls}`}>{l}</span></td>
              </tr>,
              open === r.id && (
                <tr key={`${r.id}-d`}><td colSpan={6} className="px-6 py-3 bg-slate-50 text-xs space-y-1" data-testid={`round-run-detail-${r.id}`}>
                  {r.scans.map((s) => <div key={s.point_id}>✓ {s.name} — {fmt(s.at)} ({s.method === "nfc" ? "badge NFC" : "QR code"}){s.lat ? ` · GPS ${s.lat.toFixed(5)}, ${s.lon.toFixed(5)}` : ""}</div>)}
                  {(r.missed || []).map((m) => <div key={m} className="text-rose-700">✗ {m} — non validé</div>)}
                </td></tr>
              ),
            ];
          })}
        </tbody>
      </table>
    </div>
  );
}
